export default __webpack_public_path__ + "static/media/filter_user_management.1c21c08a.svg";